import { GlAlert, GlSprintf, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { helpPagePath } from '~/helpers/help_page_helper';
export default {
    name: 'ClustersDeprecationAlert',
    components: {
        GlAlert,
        GlSprintf,
        GlLink
    },
    inject: [
        'message'
    ],
    docsLink: helpPagePath('user/infrastructure/clusters/migrate_to_gitlab_agent.md'),
    deprecationEpic: 'https://gitlab.com/groups/gitlab-org/configure/-/epics/8'
};
